import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserDetailsType } from "../../types/genericType";

const initialState: UserDetailsType = {
  id: 0,
  firstName: "",
  lastName: "",
  email: "",
  isActive: false,
  role: "",
  accounts: [],
  statements: [],
  clientInfo: []
};

export const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserDetails: (
      state,
      action: PayloadAction<{ userDetails: UserDetailsType }>
    ) => {
      state.id = action.payload.userDetails.id;
      state.firstName = action.payload.userDetails.firstName;
      state.lastName = action.payload.userDetails.lastName;
      state.email = action.payload.userDetails.email;
      state.isActive = action.payload.userDetails.isActive;
      state.role = action.payload.userDetails.role;
      state.accounts = action.payload.userDetails.accounts;
      state.statements = action.payload.userDetails.statements;
      state.clientInfo = action.payload.userDetails.clientInfo || [];
    },
  },
});

export const { setUserDetails } = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
